import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from "@/components/ui/alert-dialog";
import { useTranslations } from "use-intl";
type DialogProps = {
  open: boolean;
  title?: string;
  description?: string;
  acceptText: string;
  onOpenChange: (open: boolean) => void;
  acceptCallback: () => void;
  dialogType?: "info" | "danger";
};
export function DialogAction({
  open,
  title,
  description,
  acceptText,
  onOpenChange,
  acceptCallback,
  dialogType = "danger"
}: DialogProps) {
  const t = useTranslations();
  const onDiscard = () => {
    onOpenChange(false);
  };
  return <AlertDialog open={open} data-sentry-element="AlertDialog" data-sentry-component="DialogAction" data-sentry-source-file="DialogAction.tsx">
      <AlertDialogContent className="sm:max-w-[425px]" onEscapeKeyDown={onDiscard} data-sentry-element="AlertDialogContent" data-sentry-source-file="DialogAction.tsx">
        <AlertDialogHeader data-sentry-element="AlertDialogHeader" data-sentry-source-file="DialogAction.tsx">
          <AlertDialogTitle data-sentry-element="AlertDialogTitle" data-sentry-source-file="DialogAction.tsx">{title || "Acțiune necesară"}</AlertDialogTitle>
          <AlertDialogDescription data-sentry-element="AlertDialogDescription" data-sentry-source-file="DialogAction.tsx">
            {description || "Acțiunea este ireversibilă. Sigur dorești să continui?"}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="flex flex-col gap-2" data-sentry-element="AlertDialogFooter" data-sentry-source-file="DialogAction.tsx">
          <AlertDialogAction type="button" onClick={acceptCallback} className={dialogType === "danger" ? "bg-red-700 text-white hover:bg-red-400" : ""} data-sentry-element="AlertDialogAction" data-sentry-source-file="DialogAction.tsx">
            {acceptText}
          </AlertDialogAction>
          <AlertDialogCancel type="button" onClick={onDiscard} className={dialogType === "danger" ? "bg-yellow-300 text-black hover:bg-yellow-300 hover:text-gray-400" : ""} data-sentry-element="AlertDialogCancel" data-sentry-source-file="DialogAction.tsx">
            {t("src_components_form_builder_form_components_DialogAction_tsx_0")}
          </AlertDialogCancel>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>;
}